<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vsZwZQ/image/cover.jpg?1731429775467" alt="This image is the cover for the book Priestess of The Morrigan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Priestess of The Morrigan
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Journey with the Great Queen to Deepen Your Devotion</b></p><p>Build a more personalized devotional practice and strengthen your relationship with the Morrigan using this profound book on enhancing your spiritual path. Through stories, prayers, and rituals for both groups and solitaries, <i>Priestess of the Morrigan</i> shows you how to better understand and serve the Great Queen—regardless of your gender.</p><p>Explore the true nature of the Morrigan, discover what it means to channel her voice, and learn about her role in prophecies and curse work. Create your own unique tradition with this book's ritual-building advice and guidelines for developing a yearly cycle of celebrations. Stephanie Woodfield, a devotee to the Great Queen for over twenty years, uses her personal triumphs and challenges as beacons for your journey. This extraordinary book provides everything you need to deepen your spirituality and find victory and fulfillment along your path.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Woodfield
      </h2>
      
      <p class="authorDescription body article"><P><B>Stephanie Woodfield</B> (Orlando, FL) has been a practicing Pagan for the past twenty years. A devotional polytheist, teacher, and Priestess of the Morrigan, she is one of the founding members of Morrigu's Daughters and is an organizer for several Pagan gatherings. Stephanie teaches classes on devotional work and magical practice in the US and internationally. A long time New Englander, she now resides in the Orlando area with her husband, a very pampered cat, and various reptiles. In her spare time she enjoys creating art out of skulls and other dead things. She is called to helping others forge meaningful experiences with the Morrigan, as well as the Gods and land of Ireland. Visit her at StephanieWoodfield.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?234a988a